<template>
  <router-link :to="{ name: backLink }" class="btn btn-lg btn-success" :id="id">
    <i :class="icon"></i> {{ text }}
  </router-link>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    text: {
      type: String
    },
    backLink: {
      type: String,
      default: ""
    },
    params: {
      type: Object,
      default: null
    }
  }
};
</script>
